import { gql } from '@apollo/client';

export const FREE_TEXT_POSTS_QUERY = gql`
  query freetextPosts(
    $offset: Int
    $perPage: Int
    $freeText: String
    $postCategory: [String]
    $videoType: [String]
  ) {
    posts: freetextPosts(
      request: {
        offset: $offset
        perPage: $perPage
        search: { keyword: $freeText, opr: "AND" }
        custom: { postCategory: $postCategory, videoType: $videoType }
      }
    ) {
      totalCount
      totalPage
      items {
        id
        title
        propertyType
        author {
          id
          name
          nickname
          description
          link
          total_post
        }
        tags {
          id
          name
          link
        }
        project {
          id
          name
          propertyType
          developer
          roomTypes {
            name
          }
          location {
            zone {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            district {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            road {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
          }
          transportations {
            value
            label
            link
          }
          priceTypes {
            starting_price
            level {
              value
              label
            }
          }
        }
        postCategory
        link
        videoType
        featuredImage {
          url
          title
          width
          height
        }
        totalComments
        embedVideo
        excerpt
      }
    }
  }
`;
